export const posterFieldGroups = [
  { id: 'student', title: '学员信息', fields: [
    { id: 'studentName', label: '学员姓名', required: true, visible: true },
    { id: 'studentNumber', label: '学号', required: false, visible: true },
  ] },
  { id: 'purchase', title: '购买项目', fields: [
    { id: 'projectName', label: '项目名称', required: true, visible: true },
    { id: 'quantity', label: '购买数量', required: false, visible: false },
    { id: 'projectAmount', label: '项目金额', required: false, visible: false },
    { id: 'paymentAmount', label: '支付金额', required: false, visible: false },
  ] },
  { id: 'class', title: '班级信息', fields: [
    { id: 'className', label: '班级名称', required: false, visible: true },
    { id: 'teacher', label: '任课老师', required: false, visible: true },
    { id: 'campus', label: '上课校区', required: false, visible: true },
    { id: 'classTime', label: '上课时间', required: false, visible: true },
  ] },
] as const;

export type PosterFieldId = (typeof posterFieldGroups)[number]['fields'][number]['id'];
export const initialPosterFields = Object.fromEntries(posterFieldGroups.flatMap(group => group.fields.map(field => [field.id, field.visible]))) as Record<PosterFieldId, boolean>;
